import { render } from "./OAuthApplicationForm.vue?vue&type=template&id=1d164949"
import script from "./OAuthApplicationForm.vue?vue&type=script&lang=js"
export * from "./OAuthApplicationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__